import type { ReactNode } from 'react';
import { useI18nTranslation } from '../../lib/use-i18n-translation';

export interface AuthCardProps {
  title: string;
  subtitle: string;
  children: ReactNode;
}

/** The centred card the sign-in and change-password pages share, outside the AppShell. */
export const AuthCard = ({ title, subtitle, children }: AuthCardProps) => {
  const { t } = useI18nTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm">
        <div className="mb-6 text-center">
          <p className="text-lg font-semibold tracking-tight text-foreground">{t('app.name')}</p>
          <p className="mt-0.5 text-xs text-muted-foreground">{t('app.tagline')}</p>
        </div>

        <div className="rounded-lg border border-border bg-card p-6 shadow-sm">
          <h1 className="text-xl font-semibold text-card-foreground">{title}</h1>
          <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>
          {children}
        </div>
      </div>
    </div>
  );
};

export const FormAlert = ({ message }: { message: string | null }) =>
  message ? (
    <p
      role="alert"
      className="rounded-md border border-destructive/40 bg-destructive/5 px-3 py-2 text-sm text-destructive"
    >
      {message}
    </p>
  ) : null;
